import React, {useEffect, useState} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {TextField, FormHelperText, Button, MenuItem} from '@material-ui/core';
import reusableInputStyles from '../../../components/InputStyles';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
import {useDispatch, useSelector} from 'react-redux';
import {
  fetchAllGroupCode,
  fetchClientPrefixData,
  fetchInvoiceTypeDropDownData,
  getServiceClientDetails,
  postSiteInfo,
  resetToast,
} from '../../../redux/reducers/clientMangement/Organizaation';
import PageLoader from '../../../components/PageLoader';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';
const Organization = ({
  setOpen = () => {},
  edit,
  tableData,
  siteTableData,
  handleDirty,
  organizationAccess,
}) => {
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const {
    corporateAPIdata,
    status,
    isLoading,
    dropDownData,
    successMsg,
    errorMsg,
    serviceClientInfo: siteInfo,
    allGroupCode,
    siteAPIdata,
    sitePrefixData,
  } = useSelector(({organization}) => organization);
  const [codePopover, setCodePopover] = useState(false);
  const [reportCodesData, setReportCodesData] = useState();
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const seedOnlyOptions = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetToast());
      }, 3000);
    }
  }, [successMsg, errorMsg]);

  useEffect(() => {
    dispatch(fetchAllGroupCode());
    dispatch(fetchClientPrefixData());
  }, []);

  useEffect(() => {
    if (successMsg && siteInfo?.siteId) {
      dispatch(getServiceClientDetails(siteInfo?.siteId, 'Site'));
    }
  }, [successMsg, siteInfo?.siteId]);
  const editTableData =
    allGroupCode?.length > 0 ?
      allGroupCode?.filter(
        (el) => el.siteName?.toLowerCase()?.trim() !== siteInfo?.siteName?.toLowerCase()?.trim(),
      ) :
      [];


  const siteNameData = (data) => {
    const clientData =
      tableData?.length > 0 ? allGroupCode : siteTableData?.length > 0 ? editTableData : [];
    return clientData;
  };

  const checkSiteDataExist = (value, type) => {
    if (siteNameData(siteAPIdata) && siteNameData(siteAPIdata)?.length > 0 && value ) {
      const titleData = [];
      siteNameData(siteAPIdata)?.forEach((i) => {
        if (
          i?.siteName?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          titleData.push(i);
        }
      });
      return titleData.length > 0;
    } else {
      return false;
    }
  };

  const checkGroupCodeAlreadyExist = (value) => {
    if (siteNameData(allGroupCode) && siteNameData(allGroupCode)?.length > 0 && value) {
      const ar = [];
      siteNameData(allGroupCode)?.filter((i) => {
        if (
          i?.siteName?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };

  const checkClientPrefixExisted = (value, type) => {
    if (sitePrefixData?.length > 0) {
      const titleData = [];
      sitePrefixData?.forEach((i) => {
        if (i?.toUpperCase()?.trim() === value?.toUpperCase()?.trim()) {
          titleData.push(i);
        }
      });
      return titleData.length > 0;
    } else {
      return false;
    }
  };

  const getCompanyCodesData = () => {
    if (siteAPIdata && siteAPIdata?.length > 0 ) {
      return siteAPIdata?.filter((i) => 
        i?.siteName?.toLowerCase()?.trim().startsWith(reportCodesData?.toLowerCase()?.trim()) 
      );
    } else {
      return [];
    }
  };
  const validationSchema = Yup.object().shape({
    agregateLegalCollection: Yup.mixed().test(
      'agregate Legal Collection',
      'Aggregation Legal Collection is required',
      (value) => {
        if (!value?.value) {
          return false;
        } else {
          return true;
        }
      },
    ),
    allowPaymentAgregation: Yup.mixed().test(
      'allow Payment Agregation',
      'Allow Payment Aggregation is required',
      (value) => {
        if (!value?.value) {
          return false;
        } else {
          return true;
        }
      },
    ),
    clientPrefix: edit ? null : Yup.string()
      .required('Client Prefix is required')
      .test(
        'clientPrefix',
        'Client Prefix already exists',
        (value) => !checkClientPrefixExisted(value, 'clientPrefix'),
      ),
    siteName: Yup.string()
      .required('Site Name is required')
      .test(
        'siteName',
        'Site Name already exists',
        (value) => !checkSiteDataExist(value, 'siteName'),
      )
      .trim()
      .test(
        'siteName',
        'Site Name has already been used in the past',
        (value) => !checkGroupCodeAlreadyExist(value),
      ),
    invoiceAtThisLevel: Yup.mixed().test(
      'invoice At This Level',
      'Invoice is required',
      (value) => {
        if (!value?.value) {
          return false;
        } else {
          return true;
        }
      },
    ),
    invoiceType: Yup.mixed().test('invoiceType', 'Invoice Type is required', (value, valid) => {
      const value1 = valid?.parent;
      if (!value?.valueCode && value1?.invoiceAtThisLevel?.value === 'Yes') {
        return false;
      } else {
        return true;
      }
    }),
    corporateName: Yup.mixed().test('corporateName', 'Corporate Name is required', (value) => {
      if (!value?.corporateId) {
        return false;
      } else {
        return true;
      }
    }),
  });

  useEffect(() => {
    if (status === 200) {
      setOpen(false);
    }
  }, [status]);

  const getOption = (data, property, value) => {
    if (!data || data?.length === 0) {
      return {};
    }
    const obj = data?.find((item) => item[property] === value);
    return obj ? obj : {};
  };
  const initialVal = {
    agregateLegalCollection:
      getOption(seedOnlyOptions, 'value', siteInfo?.agregateLegalCollection) || '',
    allowPaymentAgregation:
      getOption(seedOnlyOptions, 'value', siteInfo?.allowPaymentAgregation) || '',
    clientPrefix: siteInfo?.clientPrefix || '',
    corporateName: getOption(corporateAPIdata, 'corporateId', siteInfo?.corporateId) || {},
    invoiceAtThisLevel: siteInfo?.invoiceAtThisLevel ?
      getOption(seedOnlyOptions, 'value', siteInfo?.invoiceAtThisLevel) :
      {
        key: 'Y',
        value: 'Yes',
      },
    invoiceType: getOption(dropDownData?.INVOICE_TYPE, 'value', siteInfo?.invoiceType) || '',
    siteId: siteInfo?.siteId || 0,
    siteName: siteInfo?.siteName || '',
  };
  const handleSubmit = (values) => {
    if (values) {
      dispatch(submissionStart());
      const data = {
        agregateLegalCollection: values?.agregateLegalCollection?.value ?
          values?.agregateLegalCollection?.value :
          '',
        allowPaymentAgregation: values?.allowPaymentAgregation?.value ?
          values?.allowPaymentAgregation?.value :
          '',
        clientPrefix: values?.clientPrefix ? values?.clientPrefix : '',
        corporateId: values?.corporateName?.corporateId ? values.corporateName?.corporateId : 0,

        invoiceAtThisLevel: values?.invoiceAtThisLevel?.value ?
          values?.invoiceAtThisLevel?.value :
          '',
        invoiceType:
          values?.invoiceAtThisLevel?.value === 'Yes' && values?.invoiceType?.value ?
            values?.invoiceType?.value :
            '',
        siteId: siteInfo?.siteId || 0,
        siteName: values?.siteName ? values?.siteName : '',
      };
      dispatch(postSiteInfo(data));
    }
    handleDirty(false, 'fixed');
  };

  useEffect(() => {
    dispatch(fetchInvoiceTypeDropDownData());
  }, [dispatch]);

  window.onclick = function() {
    setCodePopover(false);
  };

  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialVal}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            errors,
            touched,
            handleBlur,
            handleSubmit,
            setFieldValue,
            resetForm,
            dirty,
          } = props;
          handleDirty && handleDirty(dirty);
          return (
            <div className="col-12">
              <form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <div className="form-row global-field-textfields new-standard-textfields">
                  <div className="col-sm-8 col-md-6 col-xl-4 form-group">
                    <TextField
                      // className={` ${classes.labelName} ${classes.inputLabel}`}
                      margin="dense"
                      variant="outlined"
                      placeholder={`Enter Site Name`}
                      label="Site Name"
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      name="siteName"
                      required
                      value={values.siteName}
                      // onChange={handleChange}
                      onChange={(e) => {
                        setFieldValue('siteName', e.target.value);
                        if (e.target.value) {
                          setCodePopover(true);
                          setReportCodesData(e.target.value);
                        } else if (e.target.value === '') {
                          setCodePopover(false);
                        }
                      }}
                      onBlur={handleBlur}
                      fullWidth
                      touched={touched.siteName}
                      error={Boolean(touched.siteName && errors.siteName)}
                    />
                    <FormHelperText>
                      {touched.siteName && errors?.siteName && errors.siteName}
                    </FormHelperText>
                    <div className="windowcode-popover Add-trigger-group-popover">
                      {codePopover &&
                        getCompanyCodesData()?.map((data, i) => (
                          <MenuItem key={i}>{data?.siteName}</MenuItem>
                        ))}
                    </div>
                  </div>
                  <div className={`"col-sm-8 col-md-6 col-xl-4 form-group" `}>
                    <GuiAutoComplete
                      classes={`${{
                        popper: classes.popper,
                        option: classes.option,
                      }}`}
                      name="agregateLegalCollection"
                      id="agregateLegalCollection"
                      size="small"
                      value={values.agregateLegalCollection}
                      options={seedOnlyOptions}
                      getOptionLabel={(option) => {
                        return option && option.value ?
                          option.valueCode === null ?
                            option.value :
                            option.value :
                          '';
                      }}
                      onChange={(e, value) => {
                        setFieldValue('agregateLegalCollection', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            // className={` ${classes.labelName} ${classes.selectLabel}`}
                            {...params}
                            variant="outlined"
                            touched={touched.agregateLegalCollection}
                            error={
                              touched.agregateLegalCollection && errors.agregateLegalCollection
                            }
                            margin="dense"
                            required
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            label="Aggregation Legal Collection"
                            placeholder="Select Aggregation Legal Collection"
                          />
                        </div>
                      )}
                    />
                    <FormHelperText style={{color: 'red'}}>
                      {touched.agregateLegalCollection &&
                        errors?.agregateLegalCollection &&
                        errors.agregateLegalCollection}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-8 col-md-6 col-xl-4 form-group">
                    <GuiAutoComplete
                      classes={`${{
                        popper: classes.popper,
                        option: classes.option,
                      }}`}
                      name="allowPaymentAgregation"
                      id="allowPaymentAgregation"
                      size="small"
                      options={seedOnlyOptions}
                      required
                      value={values.allowPaymentAgregation}
                      getOptionLabel={(option) => {
                        return option && option.value;
                      }}
                      onChange={(e, value) => {
                        setFieldValue('allowPaymentAgregation', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            // className={` ${classes.labelName} ${classes.selectLabel}`}
                            variant="outlined"
                            margin="dense"
                            // InputLabelProps={{ shrink: true }}
                            label="Allow Payment Aggregation"
                            placeholder="Select Allow Payment Aggregation"
                            required
                            error={touched.allowPaymentAgregation && errors.allowPaymentAgregation}
                          />
                        </div>
                      )}
                    />
                    <FormHelperText>
                      {touched.allowPaymentAgregation &&
                        errors.allowPaymentAgregation &&
                        errors.allowPaymentAgregation}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-8 col-md-6 col-xl-4 form-group">
                    <TextField
                      // className={` ${classes.labelName} ${classes.inputLabel}`}
                      margin="dense"
                      variant="outlined"
                      placeholder={`Enter Client Prefix`}
                      label="Client Prefix"
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      name="clientPrefix"
                      required
                      value={values?.clientPrefix}
                      disabled = {edit}
                      onChange={(e) => {
                        setFieldValue('clientPrefix', e.target.value);
                      }}
                      onBlur={handleBlur}
                      fullWidth
                      touched={touched.clientPrefix}
                      error={Boolean(touched.clientPrefix && errors.clientPrefix)}
                    />
                    <FormHelperText>
                      {touched.clientPrefix && errors?.clientPrefix && errors.clientPrefix}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-8 col-md-6 col-xl-4 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="corporateName"
                      id="corporateName"
                      size="small"
                      disabled = {edit}
                      value={values.corporateName}
                      options={corporateAPIdata || []}
                      getOptionLabel={(option) => {
                        return option.corporateName || '';
                      }}
                      onChange={(e, value) => {
                        setFieldValue('corporateName', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            variant="outlined"
                            margin="dense"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            label="Corporate Name"
                            required
                            placeholder="Select Corporate Name"
                            // className={` ${classes.labelName} ${classes.selectLabel}`}
                            touched={touched.corporateName}
                            error={touched.corporateName && errors.corporateName}
                          />
                        </div>
                      )}
                    />
                    <FormHelperText>
                      {touched.corporateName && errors.corporateName && errors.corporateName}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-8 col-md-6 col-xl-4 form-group">
                    <GuiAutoComplete
                      classes={`${{
                        popper: classes.popper,
                        option: classes.option,
                      }}`}
                      name="invoiceAtThisLevel"
                      id="invoiceAtThisLevel"
                      size="small"
                      options={seedOnlyOptions}
                      required
                      value={values.invoiceAtThisLevel}
                      getOptionLabel={(option) => {
                        return option && option.value;
                      }}
                      onChange={(e, value) => {
                        setFieldValue('invoiceAtThisLevel', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            // className={` ${classes.labelName} ${classes.selectLabel}`}
                            variant="outlined"
                            margin="dense"
                            // InputLabelProps={{ shrink: true }}
                            label="Invoice"
                            placeholder="Select Invoice"
                            required
                            error={touched.invoiceAtThisLevel && errors.invoiceAtThisLevel}
                          />
                        </div>
                      )}
                    />
                    <FormHelperText>
                      {touched.invoiceAtThisLevel &&
                        errors.invoiceAtThisLevel &&
                        errors.invoiceAtThisLevel}
                    </FormHelperText>
                  </div>
                  {values?.invoiceAtThisLevel?.value === 'Yes' && (
                    <div className="col-sm-8 col-md-6 col-xl-4 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="invoiceType"
                        id="invoiceType"
                        size="small"
                        options={dropDownData?.INVOICE_TYPE || []}
                        required
                        value={values.invoiceType}
                        getOptionLabel={(option) => {
                          return option?.value || '';
                        }}
                        onChange={(e, value) => {
                          setFieldValue('invoiceType', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              // className={` ${classes.labelName} ${classes.selectLabel}`}
                              variant="outlined"
                              margin="dense"
                              // InputLabelProps={{ shrink: true }}
                              label="Invoice Type"
                              placeholder="Select Invoice Type"
                              required
                              error={touched.invoiceType && errors.invoiceType}
                            />
                          </div>
                        )}
                      />
                      <FormHelperText>
                        {touched.invoiceType && errors.invoiceType && errors.invoiceType}
                      </FormHelperText>
                    </div>
                  )}
                </div>
                <div className="d-flex justify-content-center align-items-center new-standard-textfields">
                  <Button
                    variant="outlined"
                    className={`reset-btn mr-1 ${classes.buttonRoot}`}
                    onClick={() => {
                      resetForm();
                    }}
                  >
                    Reset
                  </Button>
                  <Button
                    variant="outlined"
                    type="submit"
                    disabled={(edit && !organizationAccess?.edit) || enabledSubmission}
                    className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                  >
                    Save
                  </Button>
                </div>
              </form>
            </div>
          );
        }}
      </Formik>
      {isLoading && <PageLoader />}
    </>
  );
};

export default Organization;
